import React, { useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
const Token = () => {
    const [token, setToken] = useState();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    useEffect(() => {
        setToken(axiosConfig);
    }, [tempToken]);

    return token;
};

export default Token;
